/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsDimensionValue = {
  /**
   * Rows at the dataset's grain carrying this value inside the window
   */
  count: number;
  /**
   * For signal attributes, false distinguishes absent labels from present empty strings
   */
  present?: boolean | undefined;
  /**
   * A recorded dimension value. Signal attributes may be empty; present distinguishes an absent label.
   */
  value: string;
};

/** @internal */
export const AnalyticsDimensionValue$inboundSchema: z.ZodMiniType<
  AnalyticsDimensionValue,
  unknown
> = z.object({
  count: z.int(),
  present: z.optional(z.boolean()),
  value: z.string(),
});

export function analyticsDimensionValueFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDimensionValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDimensionValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDimensionValue' from JSON`,
  );
}
